__turbopack_context__.v({
  "label": "hfyz3q_label",
  "listItem": "hfyz3q_listItem",
  "title": "hfyz3q_title",
  "wrapper": "hfyz3q_wrapper",
});
